module["exports"] = [
  "구",
  "시",
  "군"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/city_suffix.js
// module id = 2467
// module chunks = 2